import { FC, ReactNode } from "react";

interface HeaderI {
	title: string;
	children?: ReactNode;
}

export const SectionHeader: FC<HeaderI> = ({ title, children }) => {
	return (
		<div className='mx-auto max-w-3xl text-center'>
			<h2 className='text-3xl font-bold tracking-tight text-secondary'>
				{title}
			</h2>
			<p className='mt-4 text-lg text-gray-500'>{children}</p>
		</div>
	);
};
